module.exports = __webpack_public_path__ + "static/media/found-logo.eb053a8b.webp";